import PropTypes from 'prop-types'

import Icon from '../../Icons'

function SearchField({ onChange, value, additionalClass = '', disabled = false, ...props }) {
  return (
    <div className={`field-search ${additionalClass || ''} ${disabled ? 'is-disabled' : ''}`}>
      <input
        type="text"
        autoComplete="off"
        onChange={onChange}
        value={value}
        disabled={disabled}
        {...props}
      />
      <Icon icon="search" />
    </div>
  )
}

SearchField.propTypes = {
  placeholder: PropTypes.string.isRequired,
  additionalClass: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
}

export default SearchField
